var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{'selected' : _vm.isSelected},on:{"click":_vm.selectGroup}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.group.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }